<template>
  <div class="print_wrapper">
    <div
      :key="item.key"
      :style="item.style"
      v-for="item in randomItems"
      class="hello"
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </div>
  </div>
</template>

<script>
import * as R from "ramda";
export default {
  data() {
    return {
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    };
  },
  computed: {
    randomItems() {
      let ri = R.map((k) => {
        return {
          key: k,
          style: `height:${
            Math.floor(Math.random() * 400) + 50
          }px;background:#${Math.round(Math.random() * 0xffffff).toString(16)}`,
        };
      }, this.items);
      return ri;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.print_wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: start;
  .hello {
    background: $gray200;

    margin: 10px;
    // page-break-before: auto;
    page-break-inside: avoid;
  }
}
</style>